query allFootballPlayers(
  $first: Int,
  $offset: Int,
  $filter: FootballPlayerFilter,
  $condition: FootballPlayerCondition
  ) {
  players: allFootballPlayers(
      first: $first,
      offset: $offset,
      filter: $filter,
      condition: $condition
    ) {
    nodes {
      playerMappings: footballPlayerMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingId
          mappingType
          createdAt
          createdBy
          updatedAt
          updatedBy
          playerIndex
          playerTeamMapping: playerTeamMappingsByFeedAndPlayerExtId {
            nodes {
              discriminator
              team: footballTeamMapping { 
                extRef
              }
            }
          }
        }
      }
      name
      source
      playerId
      playerIndex
    }
    totalCount
  }
}
